export const TRANSLATIONS = {
  en: {
    brand: "BhoomiMitra",
    brandDevanagari: "भूमिमित्र",
    tagline: "Ek Bhoomi • Ek Mitra • Ek Bharosa",
    taglineDeva: "एक भूमि • एक मित्र • एक भरोसा",
    heroTitle: "Buy & Sell Property Across Bharat",
    heroSub: "List your land, plot, shop or house with 3D view, verified papers and precise map location — every listing analysed on Vastu.",
    exploreBtn: "Explore Properties",
    sellBtn: "Sell Your Property",
    nav: { home: "Home", browse: "Browse", sell: "Sell", myListings: "My Listings", myEnquiries: "My Enquiries", subscribe: "Subscribe", about: "About", login: "Login", register: "Register", logout: "Logout" },
    categories: { ghar: "House", plot: "Plot", shop: "Shop", jamin: "Land" },
    filters: { all: "All", search: "Search by title, city, area…", city: "City", state: "State", price: "Price", minPrice: "Min ₹", maxPrice: "Max ₹", apply: "Apply", reset: "Reset" },
    units: { sqft: "sq.ft", gaj: "gaj", acre: "acre", bigha: "bigha", sqm: "sq.m", per_sqft: "per sq.ft", per_gaj: "per gaj", per_acre: "per acre", total: "Total" },
    property: {
      details: "Details", overview: "Overview", size: "Size", price: "Price", location: "Location",
      threeD: "3D View", gallery: "Photos", papers: "Legal Papers", seller: "Seller",
      contact: "Contact Seller", views: "views", bed: "Bed", bath: "Bath",
      description: "Description", addedOn: "Added on", by: "by",
    },
    add: {
      title: "List Your Property",
      subtitle: "Fill karo details, add photos, 3D model aur papers.",
      titleLabel: "Property Title", descLabel: "Description",
      category: "Category", size: "Size", price: "Price",
      addressLabel: "Full Address", city: "City", state: "State",
      pickLocation: "Pick location on map (click)", photos: "Photos",
      model3d: "3D Model (.glb / .gltf) – optional", papers: "Legal Papers (view-only)",
      bedrooms: "Bedrooms", bathrooms: "Bathrooms",
      publishBtn: "Publish Listing", uploading: "Uploading…", saving: "Publishing…",
      contactPhone: "Contact Phone",
    },
    auth: {
      loginTitle: "Welcome back", loginSub: "Log in to buy, sell and manage your listings.",
      registerTitle: "Create your account", registerSub: "Join thousands buying and selling property.",
      email: "Email", password: "Password", name: "Full Name", phone: "Phone (optional)",
      loginBtn: "Log In", registerBtn: "Create Account",
      or: "OR", googleBtn: "Continue with Google",
      switchToRegister: "Naya user? Register karein", switchToLogin: "Already a user? Login",
    },
    papers: {
      viewer: "Papers Viewer", secure: "Secure View – Download & screenshot restricted",
      loading: "Loading document…", cantDownload: "Download blocked for seller protection.",
      hiddenNotice: "Content hidden. Return to this tab to view again.",
      loginRequired: "Please log in to view the papers.",
    },
    empty: { noResults: "Koi property nahi mili", tryDifferent: "Filters change karke try karein" },
    common: { back: "Back", cancel: "Cancel", save: "Save", delete: "Delete", loading: "Loading…", yes: "Haan", no: "Nahi" },
    footer: "Made in Bharat with warmth. All listings independently verified by owners.",
  },
  hi: {
    brand: "BhoomiMitra",
    brandDevanagari: "भूमिमित्र",
    tagline: "एक भूमि • एक मित्र • एक भरोसा",
    taglineDeva: "एक भूमि • एक मित्र • एक भरोसा",
    heroTitle: "पूरे भारत में प्रॉपर्टी ख़रीदें और बेचें",
    heroSub: "अपनी ज़मीन, प्लॉट, दुकान या घर लिस्ट करें – 3D व्यू, वेरिफ़ाइड पेपर, सटीक मैप लोकेशन एवं वास्तु विश्लेषण के साथ।",
    exploreBtn: "प्रॉपर्टी देखें",
    sellBtn: "अपनी प्रॉपर्टी बेचें",
    nav: { home: "होम", browse: "देखें", sell: "बेचें", myListings: "मेरी लिस्टिंग", myEnquiries: "मेरी पूछताछ", subscribe: "सब्सक्राइब", about: "हमारे बारे में", login: "लॉगिन", register: "रजिस्टर", logout: "लॉगआउट" },
    categories: { ghar: "घर", plot: "प्लॉट", shop: "दुकान", jamin: "ज़मीन" },
    filters: { all: "सभी", search: "टाइटल, शहर, इलाक़ा…", city: "शहर", state: "राज्य", price: "क़ीमत", minPrice: "न्यूनतम ₹", maxPrice: "अधिकतम ₹", apply: "लागू करें", reset: "रीसेट" },
    units: { sqft: "वर्ग फ़ीट", gaj: "गज़", acre: "एकड़", bigha: "बीघा", sqm: "वर्ग मी.", per_sqft: "प्रति वर्ग फ़ीट", per_gaj: "प्रति गज़", per_acre: "प्रति एकड़", total: "कुल" },
    property: {
      details: "विवरण", overview: "ओवरव्यू", size: "साइज़", price: "क़ीमत", location: "लोकेशन",
      threeD: "3D व्यू", gallery: "फ़ोटो", papers: "क़ानूनी काग़ज़ात", seller: "विक्रेता",
      contact: "विक्रेता से संपर्क करें", views: "व्यूज़", bed: "बेड", bath: "बाथ",
      description: "विवरण", addedOn: "जोड़ा गया", by: "द्वारा",
    },
    add: {
      title: "अपनी प्रॉपर्टी लिस्ट करें", subtitle: "विवरण भरें, फ़ोटो, 3D मॉडल और काग़ज़ात जोड़ें।",
      titleLabel: "प्रॉपर्टी टाइटल", descLabel: "विवरण",
      category: "श्रेणी", size: "साइज़", price: "क़ीमत",
      addressLabel: "पूरा पता", city: "शहर", state: "राज्य",
      pickLocation: "मैप पर क्लिक करके लोकेशन चुनें", photos: "फ़ोटो",
      model3d: "3D मॉडल (.glb / .gltf) – ऐच्छिक", papers: "क़ानूनी काग़ज़ात (सिर्फ़ देखने के लिए)",
      bedrooms: "बेडरूम", bathrooms: "बाथरूम",
      publishBtn: "लिस्टिंग प्रकाशित करें", uploading: "अपलोड हो रहा है…", saving: "प्रकाशित हो रहा है…",
      contactPhone: "संपर्क फ़ोन",
    },
    auth: {
      loginTitle: "वापसी पर स्वागत", loginSub: "लॉगिन करें और लिस्टिंग मैनेज करें।",
      registerTitle: "अपना अकाउंट बनाएँ", registerSub: "हज़ारों लोगों के साथ जुड़ें।",
      email: "ईमेल", password: "पासवर्ड", name: "पूरा नाम", phone: "फ़ोन (ऐच्छिक)",
      loginBtn: "लॉगिन करें", registerBtn: "अकाउंट बनाएँ",
      or: "या", googleBtn: "Google से जारी रखें",
      switchToRegister: "नए हैं? रजिस्टर करें", switchToLogin: "पहले से यूज़र? लॉगिन",
    },
    papers: {
      viewer: "काग़ज़ात व्यूअर", secure: "सुरक्षित व्यू – डाउनलोड और स्क्रीनशॉट प्रतिबंधित",
      loading: "डॉक्युमेंट लोड हो रहा है…", cantDownload: "विक्रेता सुरक्षा हेतु डाउनलोड बंद है।",
      hiddenNotice: "कंटेंट छुपा हुआ है। दोबारा देखने के लिए इस टैब पर आएँ।",
      loginRequired: "काग़ज़ात देखने के लिए लॉगिन करें।",
    },
    empty: { noResults: "कोई प्रॉपर्टी नहीं मिली", tryDifferent: "फ़िल्टर बदलकर देखें" },
    common: { back: "वापस", cancel: "रद्द", save: "सेव", delete: "डिलीट", loading: "लोड हो रहा है…", yes: "हाँ", no: "नहीं" },
    footer: "भारत में गर्मजोशी से बनाया गया। सभी लिस्टिंग मालिकों द्वारा वेरिफ़ाइड।",
  },
};

// State-wise Hindi belt (default Hindi)
export const HINDI_STATES = new Set([
  "uttar pradesh", "bihar", "madhya pradesh", "rajasthan", "haryana",
  "delhi", "jharkhand", "chhattisgarh", "himachal pradesh", "uttarakhand",
]);

// Jodhpur launch cities (city + rural belt around Jodhpur, Rajasthan)
export const JODHPUR_AREAS = [
  { name: "Jodhpur", devanagari: "जोधपुर", tag: "city" },
  { name: "Mandore", devanagari: "मंडोर", tag: "urban" },
  { name: "Bilara", devanagari: "बिलाड़ा", tag: "rural" },
  { name: "Osian", devanagari: "ओसियां", tag: "rural" },
  { name: "Phalodi", devanagari: "फलौदी", tag: "rural" },
  { name: "Balesar", devanagari: "बालेसर", tag: "rural" },
  { name: "Bhopalgarh", devanagari: "भोपालगढ़", tag: "rural" },
  { name: "Luni", devanagari: "लूनी", tag: "rural" },
  { name: "Shergarh", devanagari: "शेरगढ़", tag: "rural" },
  { name: "Piparcity", devanagari: "पीपाड़ शहर", tag: "rural" },
  { name: "Mathania", devanagari: "मथानिया", tag: "rural" },
  { name: "Lohawat", devanagari: "लोहावट", tag: "rural" },
];

